import { render, staticRenderFns } from "./DetailSparePartRequest.vue?vue&type=template&id=5b4c10de&scoped=true&"
import script from "./DetailSparePartRequest.vue?vue&type=script&lang=ts&"
export * from "./DetailSparePartRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c10de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4c10de')) {
      api.createRecord('5b4c10de', component.options)
    } else {
      api.reload('5b4c10de', component.options)
    }
    module.hot.accept("./DetailSparePartRequest.vue?vue&type=template&id=5b4c10de&scoped=true&", function () {
      api.rerender('5b4c10de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/sparepart-request/DetailSparePartRequest.vue"
export default component.exports